import http from "../http";

export async function getReports(data) {
  const response = await http.post("/batch/report/files/list", data);
  return response.data;
}
export async function getReportDetails(data) {
  const response = await http.post("/batch/report/file/match-stats", data);
  return response.data;
}
